import Sticky from "react-stickynode";
import styles from "./ResultsList.module.css";

const FixedTopParent = ({ item, isParent, parentRef, children, setSticked }) => {
  if (isParent)
    return (
      <Sticky
        // enabled={false} for web-component
        enabled={true}
        activeClass={`${styles["cpv-search-fixedTopParent"]} cpv-search-stickyListLi`}
        onStateChange={(state) => setSticked({ ...state, item })}
        onClick={(e) => e.stopPropagation()}
        bottomBoundary="#wrp_container"
      >
        <div className={styles["cpv-search-stickyContent"]}>{children}</div>
      </Sticky>
    );

  return <>{children}</>;
};

export default FixedTopParent;
